(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["koz-foundation-calculator"] && !Shopify.designMode) return;
  try {
    
class FoundationsCalculator {
  constructor(root) {
    this.root = root;
    this.currencySymbol = root.dataset.currencySymbol || '$';
    this.annualTarget = Number(root.dataset.annualTarget) || 1000000;
    this.defaultLift = Number(root.dataset.defaultLift) || 22;
    this.roasMin = Number(root.dataset.roasMin) || 1;
    this.roasMax = Number(root.dataset.roasMax) || 10;
    this.roasStep = Number(root.dataset.roasStep) || 0.1;
    this.ctaBaseUrl = root.dataset.ctaUrl || '';
    this.spendNoteTemplate = root.dataset.spendNoteTemplate || '';
    this.started = false;
    this.completedTimer = null;

    this.input = root.querySelector('[data-input="roas"]');
    this.slider = root.querySelector('[data-slider="roas"]');
    this.errorEl = root.querySelector('[data-error="roas"]');
    this.annualTargetInput = root.querySelector('[data-input="annual_target"]');
    this.annualTargetErrorEl = root.querySelector('[data-error="annual_target"]');
    this.spendNoteEls = Array.from(root.querySelectorAll('[data-output="spend_note"]'));
    this.liftInputs = Array.from(root.querySelectorAll('[data-input="rpv_lift"]'));

    this.outputs = {
      annualSaving: root.querySelector('[data-output="annual_saving"]'),
      currentRoas: root.querySelector('[data-output="current_roas"]'),
      newRoas: root.querySelector('[data-output="new_roas"]'),
      currentAnnualSpend: root.querySelector('[data-output="current_annual_spend"]'),
      improvedAnnualSpend: root.querySelector('[data-output="improved_annual_spend"]'),
    };

    this.liftLabels = Array.from(root.querySelectorAll('[data-output="lift_label"]'));
    this.cta = root.querySelector('[data-cta]');
    this.numberFormatter = new Intl.NumberFormat('en-AU', {
      maximumFractionDigits: 0,
      useGrouping: true,
    });

    this.bindEvents();
    this.bindHelpTips();
    this.formatInitialInput();
    this.syncSliderFromInput();
    this.update();
  }

  bindEvents() {
    if (this.annualTargetInput) {
      this.annualTargetInput.addEventListener('input', () => {
        this.onInteraction();
        this.formatLiveMoneyInput();
        this.update();
      });

      this.annualTargetInput.addEventListener('blur', () => {
        const value = this.parseMoney(this.annualTargetInput.value);
        if (value > 0) {
          this.annualTargetInput.value = this.formatMoneyInput(value);
        }
        this.update();
      });
    }

    if (this.input) {
      this.input.addEventListener('input', () => {
        this.onInteraction();
        this.formatLiveInput();
        this.syncSliderFromInput();
        this.update();
      });

      this.input.addEventListener('blur', () => {
        const value = this.parseRoas(this.input.value);
        if (value > 0) {
          this.input.value = this.formatRoasDisplay(value);
          this.syncSliderFromInput();
        }
        this.update();
      });
    }

    if (this.slider) {
      this.slider.addEventListener('input', () => {
        this.onInteraction();
        const value = Number(this.slider.value);
        if (this.input) {
          this.input.value = this.formatRoasDisplay(value);
        }
        this.updateSliderProgress(value);
        this.update();
      });
    }

    this.liftInputs.forEach((input) => {
      input.addEventListener('change', () => {
        this.onInteraction();
        this.update();
      });
    });

    if (this.cta) {
      this.cta.addEventListener('click', () => {
        const result = this.calculate();
        this.pushEvent('calculator_cta_clicked', result && result.valid ? result.payload : {});
      });
    }

    const form = this.root.querySelector('[data-form]');
    if (form) {
      form.addEventListener('submit', (event) => event.preventDefault());
    }
  }

  canHoverHelp() {
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  bindHelpTips() {
    this.helpItems = Array.from(this.root.querySelectorAll('[data-help]'));
    this.openHelpItem = null;
    this.helpHideTimer = null;

    this.helpItems.forEach((item) => {
      const button = item.querySelector('.foundations-calculator__help-btn');
      const pop = item.querySelector('.foundations-calculator__help-pop');
      const closeBtn = item.querySelector('[data-help-close]');
      if (!button || !pop) return;

      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (this.canHoverHelp()) {
          this.openHelp(item);
          return;
        }
        if (this.openHelpItem === item) {
          this.closeHelp();
        } else {
          this.openHelp(item);
        }
      });

      if (closeBtn) {
        closeBtn.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.closeHelp();
        });
      }

      item.addEventListener('mouseenter', () => {
        if (!this.canHoverHelp()) return;
        clearTimeout(this.helpHideTimer);
        this.openHelp(item);
      });

      item.addEventListener('mouseleave', () => {
        if (!this.canHoverHelp()) return;
        clearTimeout(this.helpHideTimer);
        this.helpHideTimer = setTimeout(() => {
          if (this.openHelpItem === item) this.closeHelp();
        }, 160);
      });

      button.addEventListener('focus', () => {
        if (!this.canHoverHelp()) return;
        clearTimeout(this.helpHideTimer);
        this.openHelp(item);
      });
    });

    document.addEventListener('click', (event) => {
      if (!this.openHelpItem) return;
      if (this.openHelpItem.contains(event.target)) return;
      this.closeHelp();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.closeHelp();
    });
  }

  openHelp(item) {
    if (!item) return;
    clearTimeout(this.helpHideTimer);

    this.helpItems.forEach((other) => {
      if (other === item) return;
      const otherButton = other.querySelector('.foundations-calculator__help-btn');
      const otherPop = other.querySelector('.foundations-calculator__help-pop');
      if (otherButton) otherButton.setAttribute('aria-expanded', 'false');
      if (otherPop) otherPop.hidden = true;
    });

    const button = item.querySelector('.foundations-calculator__help-btn');
    const pop = item.querySelector('.foundations-calculator__help-pop');
    if (button) button.setAttribute('aria-expanded', 'true');
    if (pop) pop.hidden = false;
    this.openHelpItem = item;
    this.positionHelpPop(item);
  }

  closeHelp() {
    clearTimeout(this.helpHideTimer);
    if (!this.openHelpItem) return;

    const button = this.openHelpItem.querySelector('.foundations-calculator__help-btn');
    const pop = this.openHelpItem.querySelector('.foundations-calculator__help-pop');
    if (button) {
      button.setAttribute('aria-expanded', 'false');
      if (this.canHoverHelp() && document.activeElement === button) {
        button.blur();
      }
    }
    if (pop) {
      pop.hidden = true;
      pop.style.left = '';
      pop.style.right = '';
    }
    this.openHelpItem = null;
  }

  positionHelpPop(item) {
    const pop = item.querySelector('.foundations-calculator__help-pop');
    if (!pop || pop.hidden) return;

    pop.style.left = '0';
    pop.style.right = 'auto';

    const card = this.root.querySelector('.foundations-calculator__card') || this.root;
    const cardRect = card.getBoundingClientRect();
    const popRect = pop.getBoundingClientRect();
    const overflowRight = popRect.right - cardRect.right + 8;

    if (overflowRight > 0) {
      pop.style.left = 'auto';
      pop.style.right = '0';
    }
  }

  onInteraction() {
    if (!this.started) {
      this.started = true;
      this.pushEvent('calculator_started', {});
    }
  }

  formatInitialInput() {
    if (this.annualTargetInput) {
      const target = this.parseMoney(this.annualTargetInput.value) || this.annualTarget;
      if (target > 0) {
        this.annualTargetInput.value = this.formatMoneyInput(target);
      }
    }

    if (!this.input) return;
    const value = this.parseRoas(this.input.value);
    if (value > 0) {
      this.input.value = this.formatRoasDisplay(value);
    }
  }

  formatLiveInput() {
    if (!this.input) return;
    const cleaned = String(this.input.value).replace(/[^\d.]/g, '');
    const parts = cleaned.split('.');
    this.input.value = parts.length > 1 ? `${parts[0]}.${parts.slice(1).join('').slice(0, 2)}` : cleaned;
  }

  parseMoney(value) {
    const digits = String(value || '').replace(/[^\d]/g, '');
    if (!digits) return 0;
    const parsed = Number(digits);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  formatMoneyInput(value) {
    const safe = Number.isFinite(value) && value >= 0 ? Math.round(value) : 0;
    return this.numberFormatter.format(safe);
  }

  formatLiveMoneyInput() {
    if (!this.annualTargetInput) return;
    const value = this.parseMoney(this.annualTargetInput.value);
    this.annualTargetInput.value = value ? this.formatMoneyInput(value) : '';
  }

  getAnnualTarget() {
    if (this.annualTargetInput) {
      return this.parseMoney(this.annualTargetInput.value);
    }
    return this.annualTarget;
  }

  parseRoas(value) {
    const cleaned = String(value || '').replace(/[^\d.]/g, '');
    if (!cleaned) return 0;
    const parsed = Number(cleaned);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  clampRoas(value) {
    if (!Number.isFinite(value)) return this.roasMin;
    return Math.min(this.roasMax, Math.max(this.roasMin, value));
  }

  syncSliderFromInput() {
    if (!this.slider || !this.input) return;
    const value = this.parseRoas(this.input.value);
    if (value > 0) {
      const clamped = this.clampRoas(value);
      this.slider.value = String(clamped);
      this.updateSliderProgress(clamped);
    } else {
      this.updateSliderProgress(this.roasMin);
    }
  }

  updateSliderProgress(value) {
    if (!this.slider) return;
    const min = this.roasMin;
    const max = this.roasMax;
    const range = max - min;
    const progress = range > 0 ? ((value - min) / range) * 100 : 0;
    this.slider.style.setProperty('--slider-progress', `${Math.min(100, Math.max(0, progress))}%`);
  }

  roundCurrency(value) {
    if (!Number.isFinite(value) || value < 0) return 0;
    return Math.round(value / 100) * 100;
  }

  formatCurrency(value) {
    const safe = Number.isFinite(value) && value >= 0 ? value : 0;
    return `${this.currencySymbol}${this.numberFormatter.format(Math.round(safe))}`;
  }

  formatRoasDisplay(value) {
    const safe = Number.isFinite(value) && value >= 0 ? value : 0;
    const fixed = safe.toFixed(2);
    if (fixed.endsWith('00')) return `${Math.round(safe)}.0`;
    if (fixed.endsWith('0')) return fixed.slice(0, -1);
    return fixed;
  }

  setFieldError(input, errorEl, message) {
    if (errorEl) {
      if (message) {
        errorEl.textContent = message;
        errorEl.hidden = false;
      } else {
        errorEl.textContent = '';
        errorEl.hidden = true;
      }
    }

    if (input) {
      if (message) {
        input.setAttribute('aria-invalid', 'true');
      } else {
        input.removeAttribute('aria-invalid');
      }
    }
  }

  setError(message) {
    this.setFieldError(this.input, this.errorEl, message);
  }

  setTargetError(message) {
    this.setFieldError(this.annualTargetInput, this.annualTargetErrorEl, message);
  }

  getSelectedLift() {
    const selected = this.liftInputs.find((input) => input.checked);
    const lift = selected ? Number(selected.value) : this.defaultLift;
    return Number.isFinite(lift) && lift > 0 ? lift : this.defaultLift;
  }

  calculate() {
    const roas = this.parseRoas(this.input ? this.input.value : 0);
    const annualTarget = this.getAnnualTarget();
    const lift = this.getSelectedLift();
    let valid = true;

    this.setError('');
    this.setTargetError('');

    if (annualTarget <= 0) {
      this.setTargetError('Enter an annual revenue target greater than zero.');
      valid = false;
    }

    if (roas <= 0) {
      this.setError('Enter a ROAS greater than zero.');
      valid = false;
    }

    if (!valid) {
      return { valid: false, annualTarget };
    }

    const improvedRoas = roas * (1 + lift / 100);
    const currentAnnualSpend = annualTarget / roas;
    const improvedAnnualSpend = annualTarget / improvedRoas;
    const currentRounded = this.roundCurrency(currentAnnualSpend);
    const improvedRounded = this.roundCurrency(improvedAnnualSpend);
    const annualSaved = Math.max(0, currentRounded - improvedRounded);
    const monthlySaved = this.roundCurrency((currentAnnualSpend - improvedAnnualSpend) / 12);
    const percentSaved = Math.round((1 - 1 / (1 + lift / 100)) * 100);

    const payload = {
      current_roas: Number(roas.toFixed(4)),
      improved_roas: Number(improvedRoas.toFixed(4)),
      rpv_lift: lift,
      annual_target: annualTarget,
      annual_saving: annualSaved,
      monthly_saving: monthlySaved,
      percentage_saved: percentSaved,
    };

    return {
      valid: true,
      lift,
      roas,
      annualTarget,
      improvedRoas,
      currentAnnualSpend: currentRounded,
      improvedAnnualSpend: improvedRounded,
      annualSaved,
      monthlySaved,
      percentSaved,
      payload,
    };
  }

  updateCtaHref(result) {
    if (!this.cta || !this.ctaBaseUrl) return;

    try {
      const url = new URL(this.ctaBaseUrl, window.location.origin);
      if (result && result.valid) {
        url.searchParams.set('roas', this.formatRoasDisplay(result.roas));
        url.searchParams.set('improved_roas', this.formatRoasDisplay(result.improvedRoas));
        url.searchParams.set('rpv_lift', String(result.lift));
        url.searchParams.set('annual_target', String(result.annualTarget));
        url.searchParams.set('monthly_saving', String(result.monthlySaved));
        url.searchParams.set('annual_saving', String(result.annualSaved));
        url.searchParams.set('percentage_saved', String(result.percentSaved));
      }
      this.cta.href = url.toString();
    } catch (error) {
      this.cta.href = this.ctaBaseUrl;
    }
  }

  update() {
    const result = this.calculate();
    const selectedLift = result.valid ? result.lift : this.getSelectedLift();

    this.liftLabels.forEach((el) => {
      el.textContent = String(selectedLift);
    });

    this.updateSpendNotes(result.annualTarget || 0);

    if (!result.valid) {
      if (this.outputs.annualSaving) this.outputs.annualSaving.textContent = this.formatCurrency(0);
      if (this.outputs.currentRoas) this.outputs.currentRoas.textContent = '0.0';
      if (this.outputs.newRoas) this.outputs.newRoas.textContent = '0.0';
      if (this.outputs.currentAnnualSpend) this.outputs.currentAnnualSpend.textContent = this.formatCurrency(0);
      if (this.outputs.improvedAnnualSpend) this.outputs.improvedAnnualSpend.textContent = this.formatCurrency(0);
      this.updateCtaHref(null);
      return;
    }

    if (this.outputs.annualSaving) {
      this.outputs.annualSaving.textContent = this.formatCurrency(result.annualSaved);
    }
    if (this.outputs.currentRoas) {
      this.outputs.currentRoas.textContent = this.formatRoasDisplay(result.roas);
    }
    if (this.outputs.newRoas) {
      this.outputs.newRoas.textContent = this.formatRoasDisplay(result.improvedRoas);
    }
    if (this.outputs.currentAnnualSpend) {
      this.outputs.currentAnnualSpend.textContent = this.formatCurrency(result.currentAnnualSpend);
    }
    if (this.outputs.improvedAnnualSpend) {
      this.outputs.improvedAnnualSpend.textContent = this.formatCurrency(result.improvedAnnualSpend);
    }

    this.updateCtaHref(result);

    clearTimeout(this.completedTimer);
    this.completedTimer = setTimeout(() => {
      this.pushEvent('calculator_completed', result.payload);
    }, 600);
  }

  updateSpendNotes(annualTarget) {
    if (!this.spendNoteTemplate || !this.spendNoteEls.length) return;
    const formatted = this.formatCurrency(annualTarget);
    const text = this.spendNoteTemplate.replace(/\[target\]/g, formatted);
    this.spendNoteEls.forEach((el) => {
      el.textContent = text;
    });
  }

  pushEvent(eventName, payload) {
    if (!window.dataLayer || !Array.isArray(window.dataLayer)) return;
    window.dataLayer.push({
      event: eventName,
      calculator: 'foundation_roas_calculator',
      ...payload,
    });
  }
}

function initFoundationsCalculators(scope = document) {
  scope.querySelectorAll('.foundations-calculator').forEach((root) => {
    const version = root.dataset.fcVersion || '1';
    if (root.dataset.initialized === version) return;
    new FoundationsCalculator(root);
    root.dataset.initialized = version;
  });
}

function bootFoundationsCalculators() {
  initFoundationsCalculators();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootFoundationsCalculators);
} else {
  bootFoundationsCalculators();
}

if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    initFoundationsCalculators(event.target);
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["koz-permalink-generator"] && !Shopify.designMode) return;
  try {
    
(function () {
  var LS_DOMAIN = 'kozler-permalink-domain';
  var LS_RECENT = 'kozler-permalink-recent';
  var LS_HOWTO = 'kozler-permalink-howto-quiet';
  var VARIANT_URL_WARN = 50;

  function slugify(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9._-]/g, '')
      .replace(/-+/g, '-');
  }

  function normalizeDomain(raw) {
    return String(raw || '')
      .trim()
      .replace(/^(https?:\/\/)?/i, '')
      .split('/')[0]
      .split('?')[0]
      .toLowerCase();
  }

  function brandFromDomain(raw) {
    var host = normalizeDomain(raw).replace(/^www\./i, '');
    var suffixes = ['myshopify.com', 'com.au', 'net.au', 'org.au', 'co.nz', 'co.uk', 'org.uk', 'com', 'net', 'org', 'io', 'co', 'shop'];
    var brand = '';
    var i;
    for (i = 0; i < suffixes.length; i++) {
      var suf = '.' + suffixes[i];
      if (host.length > suf.length && host.slice(-suf.length) === suf) {
        var labels = host.slice(0, -suf.length).split('.');
        brand = labels[labels.length - 1];
        break;
      }
    }
    if (!brand) brand = host.split('.')[0] || '';
    brand = brand.replace(/[^a-z0-9-]+/gi, '');
    if (!brand) return 'Store';
    return brand.charAt(0).toUpperCase() + brand.slice(1);
  }

  function qrDownloadFilename(domain) {
    return brandFromDomain(domain) + ' Kozler Permalink QR Code.png';
  }

  function parseHowToEmbed(raw) {
    raw = String(raw || '').trim();
    if (!raw) return null;

    function attr(html, name) {
      var quoted = html.match(new RegExp(name + '=["\']([^"\']+)["\']', 'i'));
      if (quoted) return quoted[1];
      var bare = html.match(new RegExp(name + '=([^\\s>]+)', 'i'));
      return bare ? bare[1] : '';
    }

    var hsvId = attr(raw, 'data-hsv-id');
    var portalId = attr(raw, 'data-hs-portal-id');
    if (hsvId && /^\d+$/.test(hsvId)) {
      return {
        type: 'hubspot',
        videoId: hsvId,
        portalId: /^\d+$/.test(portalId) ? portalId : '',
        iframeSrc: portalId && /^\d+$/.test(portalId)
          ? 'https://play.hubspotvideo.com/v/' + portalId + '/id/' + hsvId + '?autoplay=false'
          : 'https://play.hubspotvideo.com/embed/v/' + hsvId + '?autoplay=false'
      };
    }

    var src = raw;
    var iframeMatch = raw.match(/<iframe[^>]+src=["']([^"']+)["']/i);
    if (!iframeMatch) iframeMatch = raw.match(/<iframe[^>]+src=([^\s>]+)/i);
    if (iframeMatch) src = iframeMatch[1].replace(/&amp;/g, '&').replace(/^["']|["']$/g, '');
    if (!/^https?:\/\//i.test(src)) src = 'https://' + src;
    var url;
    try { url = new URL(src); } catch (err) { return null; }
    if (url.protocol !== 'https:') return null;
    var host = url.hostname.toLowerCase();

    if (host === 'play.hubspotvideo.com' || host === 'play-fast.hubspotvideo.com') {
      url.searchParams.set('autoplay', 'false');
      return { type: 'iframe', src: url.toString() };
    }

    var ytId = '';
    if (host === 'youtu.be') ytId = url.pathname.replace(/^\//, '').split('/')[0];
    if (
      host === 'youtube.com' || host === 'www.youtube.com' || host === 'm.youtube.com' ||
      host === 'youtube-nocookie.com' || host === 'www.youtube-nocookie.com'
    ) {
      ytId = url.searchParams.get('v') || '';
      if (!ytId) {
        var ytPath = url.pathname.match(/\/(?:embed|shorts|live)\/([^/?]+)/);
        if (ytPath) ytId = ytPath[1];
      }
    }
    if (ytId && /^[a-zA-Z0-9_-]{6,}$/.test(ytId)) {
      return { type: 'iframe', src: 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(ytId) + '?rel=0&autoplay=0' };
    }

    if (host === 'vimeo.com' || host === 'www.vimeo.com' || host === 'player.vimeo.com') {
      var vimeoParts = url.pathname.split('/').filter(Boolean);
      var vimeoId = vimeoParts.filter(function (p) { return /^\d+$/.test(p); }).pop() || '';
      if (vimeoId) {
        return { type: 'iframe', src: 'https://player.vimeo.com/video/' + vimeoId + '?autoplay=0' };
      }
    }

    var isShopifyCdn = /(^|\.)cdn\.shopify\.com$/i.test(host) || /(^|\.)shopifycdn\.com$/i.test(host);
    var isFileVideo = /\.(mp4|webm|mov|m4v|ogg)(\?|$)/i.test(url.pathname) || (isShopifyCdn && /\/videos\//i.test(url.pathname));
    if (isFileVideo) return { type: 'video', src: url.toString() };

    return null;
  }

  function localePath(locale) {
    var loc = String(locale || '').trim().replace(/^\/+|\/+$/g, '');
    return loc ? '/' + loc : '';
  }

  function isValidDomain(domain) {
    return /^[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)+$/i.test(domain);
  }

  function toBase64Url(str) {
    return btoa(unescape(encodeURIComponent(str)))
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=+$/g, '');
  }

  function fromBase64Url(str) {
    var pad = str.replace(/-/g, '+').replace(/_/g, '/');
    while (pad.length % 4) pad += '=';
    return decodeURIComponent(escape(atob(pad)));
  }

  function formatMoney(cents, format) {
    var amount = (Number(cents) / 100).toFixed(2);
    var withComma = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var fmt = format || '${{amount}}';
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(Number(cents) / 100)))
      .replace(/\{\{\s*amount\s*\}\}/g, withComma)
      .replace(/<[^>]+>/g, '')
      .trim();
  }

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve, reject) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      try {
        document.execCommand('copy');
        resolve();
      } catch (err) {
        reject(err);
      } finally {
        document.body.removeChild(ta);
      }
    });
  }

  function KozPermalink(root) {
    this.root = root;
    this.metaCache = {};
    this.shopMeta = null;
    this.pendingProduct = null;
    this.lastFocus = null;
    this.toastTimer = null;
    this.previewTimer = null;
    this.bulkRows = [];
    this.bind();
    this.addLine();
    this.restoreLocal();
    this.restoreShare();
    this.renderRecent();
    this.syncHowtoChip();
    this.schedulePreview();
  }

  KozPermalink.prototype.el = function (name) {
    return this.root.querySelector('[data-kozperm="' + name + '"]');
  };

  KozPermalink.prototype.bind = function () {
    var self = this;
    this.el('add-line').addEventListener('click', function () { self.addLine(); });
    this.el('fetch-product').addEventListener('click', function () { self.fetchProduct(); });
    this.el('generate').addEventListener('click', function () { self.generate(true); });
    this.el('clear').addEventListener('click', function () { self.clearForm(); });
    this.el('add-attr').addEventListener('click', function () { self.addKv('attr-list'); });
    this.el('add-prop').addEventListener('click', function () { self.addKv('prop-list'); });
    this.el('bulk-run').addEventListener('click', function () { self.runBulk(); });
    this.el('bulk-csv').addEventListener('click', function () { self.downloadCsv(); });
    this.el('copy-share').addEventListener('click', function () { self.copyShareLink(); });
    this.el('download-qr').addEventListener('click', function () { self.downloadQr(); });
    this.el('modal-close').addEventListener('click', function () { self.closeModal(); });
    this.el('modal-backdrop').addEventListener('click', function () { self.closeModal(); });
    this.el('select-all-variants').addEventListener('click', function () { self.toggleSelectAllVariants(); });
    this.el('add-selected-variants').addEventListener('click', function () { self.addSelectedVariants(); });
    var howtoHero = this.el('howto-hero');
    var howtoCorner = this.el('howto-corner');
    var howtoDismiss = this.el('howto-dismiss');
    var howtoClose = this.el('howto-close');
    var howtoBackdrop = this.el('howto-backdrop');
    if (howtoHero) howtoHero.addEventListener('click', function () { self.openHowtoModal(); });
    if (howtoCorner) howtoCorner.addEventListener('click', function () { self.openHowtoModal(); });
    if (howtoDismiss) howtoDismiss.addEventListener('click', function (e) {
      e.stopPropagation();
      self.quietHowto();
    });
    if (howtoClose) howtoClose.addEventListener('click', function () { self.closeHowtoModal(); });
    var howtoExit = this.el('howto-exit');
    if (howtoExit) howtoExit.addEventListener('click', function (e) {
      e.stopPropagation();
      self.closeHowtoModal();
    });
    var howtoModal = this.el('howto-modal');
    if (howtoModal) {
      howtoModal.addEventListener('click', function (e) {
        if (Date.now() - (self.howtoOpenedAt || 0) < 500) return;
        if (self.isHowtoMediaEvent(e)) return;
        var panel = self.el('howto-panel');
        var exitBtn = self.el('howto-exit');
        if (exitBtn && (e.target === exitBtn || exitBtn.contains(e.target))) return;
        if (panel && panel.contains(e.target)) return;
        self.closeHowtoModal();
      });
    }
    if (howtoBackdrop) {
      howtoBackdrop.addEventListener('click', function (e) {
        if (Date.now() - (self.howtoOpenedAt || 0) < 500) return;
        if (self.isHowtoMediaEvent(e)) return;
        self.closeHowtoModal();
      });
    }
    this.el('domain').addEventListener('blur', function () { self.verifyDomain(); });
    this.root.addEventListener('input', function () { self.schedulePreview(); });
    this.root.addEventListener('change', function () { self.schedulePreview(); });
    this.root.querySelectorAll('[data-copy]').forEach(function (btn) {
      btn.addEventListener('click', function () { self.copyResult(btn.getAttribute('data-copy')); });
    });
    this.root.querySelectorAll('[data-utm]').forEach(function (input) {
      input.addEventListener('blur', function () {
        input.value = slugify(input.value);
        self.schedulePreview();
      });
    });
    this.root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        if (self.el('howto-modal') && !self.el('howto-modal').hidden) {
          self.closeHowtoModal();
          return;
        }
        if (!self.el('modal').hidden) self.closeModal();
      }
      self.trapFocus(e);
    });
  };

  KozPermalink.prototype.toast = function (msg, isError) {
    var el = this.el('toast');
    el.textContent = msg;
    el.classList.toggle('is-error', !!isError);
    el.classList.add('is-visible');
    clearTimeout(this.toastTimer);
    this.toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 3000);
  };

  KozPermalink.prototype.addLine = function (data) {
    data = data || {};
    var wrap = this.el('lines');
    var row = document.createElement('div');
    row.className = 'kozperm__line';
    row.innerHTML =
      '<div class="kozperm__field">' +
        '<label class="kozperm__label">Variant ID</label>' +
        '<input class="kozperm__input" data-field="variantId" inputmode="numeric" placeholder="1234567890">' +
        '<div class="kozperm__product-chip" data-field="chip" hidden></div>' +
      '</div>' +
      '<div class="kozperm__field">' +
        '<label class="kozperm__label">Selling plan</label>' +
        '<select class="kozperm__select" data-field="sellingPlan"></select>' +
        '<input class="kozperm__input" data-field="sellingPlanCustom" placeholder="Or paste selling plan ID" hidden>' +
      '</div>' +
      '<div class="kozperm__field">' +
        '<label class="kozperm__label">Qty</label>' +
        '<input class="kozperm__input" data-field="quantity" type="number" min="1" value="1">' +
      '</div>' +
      '<button type="button" class="kozperm__icon-btn" data-field="remove" aria-label="Remove product">' +
        '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path fill-rule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd"/></svg>' +
      '</button>';
    wrap.appendChild(row);
    this.setSellingPlans(row, data.plans || []);
    if (data.variantId) row.querySelector('[data-field="variantId"]').value = data.variantId;
    if (data.quantity) row.querySelector('[data-field="quantity"]').value = data.quantity;
    if (data.title) {
      var chip = row.querySelector('[data-field="chip"]');
      chip.hidden = false;
      chip.textContent = data.title;
    }
    if (data.sellingPlanId) {
      var sel = row.querySelector('[data-field="sellingPlan"]');
      sel.value = data.sellingPlanId;
      if (sel.value !== String(data.sellingPlanId)) {
        sel.value = '__custom';
        var custom = row.querySelector('[data-field="sellingPlanCustom"]');
        custom.hidden = false;
        custom.value = data.sellingPlanId;
      }
    }
    var self = this;
    row.querySelector('[data-field="remove"]').addEventListener('click', function () {
      row.remove();
      if (!wrap.children.length) self.addLine();
      self.updateModeNotice();
      self.schedulePreview();
    });
    row.querySelector('[data-field="sellingPlan"]').addEventListener('change', function (e) {
      var custom = row.querySelector('[data-field="sellingPlanCustom"]');
      custom.hidden = e.target.value !== '__custom';
      self.updateModeNotice();
      self.schedulePreview();
    });
    this.updateModeNotice();
    this.schedulePreview();
    return row;
  };

  KozPermalink.prototype.setSellingPlans = function (row, plans) {
    var sel = row.querySelector('[data-field="sellingPlan"]');
    sel.innerHTML = '';
    var none = document.createElement('option');
    none.value = '';
    none.textContent = 'One-time (no selling plan)';
    sel.appendChild(none);
    (plans || []).forEach(function (plan) {
      var opt = document.createElement('option');
      opt.value = plan.id;
      opt.textContent = plan.name;
      sel.appendChild(opt);
    });
    var custom = document.createElement('option');
    custom.value = '__custom';
    custom.textContent = 'Custom ID…';
    sel.appendChild(custom);
  };

  KozPermalink.prototype.lineSellingPlan = function (row) {
    var sel = row.querySelector('[data-field="sellingPlan"]');
    if (sel.value === '__custom') return row.querySelector('[data-field="sellingPlanCustom"]').value.trim();
    return sel.value.trim();
  };

  KozPermalink.prototype.addKv = function (listName, key, value) {
    var list = this.el(listName);
    var row = document.createElement('div');
    row.className = 'kozperm__kv';
    row.innerHTML =
      '<input class="kozperm__input" data-k placeholder="key">' +
      '<input class="kozperm__input" data-v placeholder="value">' +
      '<button type="button" class="kozperm__icon-btn" aria-label="Remove row">×</button>';
    if (key) row.querySelector('[data-k]').value = key;
    if (value) row.querySelector('[data-v]').value = value;
    var self = this;
    row.querySelector('button').addEventListener('click', function () {
      row.remove();
      self.schedulePreview();
    });
    list.appendChild(row);
    return row;
  };

  KozPermalink.prototype.readKv = function (listName) {
    var out = {};
    this.el(listName).querySelectorAll('.kozperm__kv').forEach(function (row) {
      var k = row.querySelector('[data-k]').value.trim();
      var v = row.querySelector('[data-v]').value.trim();
      if (k) out[k] = v;
    });
    return out;
  };

  KozPermalink.prototype.collectItems = function () {
    var items = [];
    var self = this;
    this.el('lines').querySelectorAll('.kozperm__line').forEach(function (row) {
      items.push({
        variantId: row.querySelector('[data-field="variantId"]').value.trim(),
        quantity: row.querySelector('[data-field="quantity"]').value.trim() || '1',
        sellingPlanId: self.lineSellingPlan(row),
        row: row
      });
    });
    return items;
  };

  KozPermalink.prototype.collectState = function () {
    var dest = this.root.querySelector('[data-kozperm="dest"]:checked');
    var utm = {};
    this.root.querySelectorAll('[data-utm]').forEach(function (input) {
      var val = slugify(input.value);
      if (val) utm[input.getAttribute('data-utm')] = val;
    });
    return {
      domain: normalizeDomain(this.el('domain').value),
      locale: this.el('locale').value.trim(),
      destination: dest ? dest.value : 'cart',
      clearCart: this.el('clear-cart').checked,
      discount: this.el('discount').value.trim(),
      note: this.el('note').value.trim(),
      ref: this.el('ref').value.trim(),
      attributes: this.readKv('attr-list'),
      properties: this.readKv('prop-list'),
      utm: utm,
      items: this.collectItems()
    };
  };

  KozPermalink.prototype.validate = function (state, showUi) {
    var errors = [];
    this.root.querySelectorAll('.is-invalid').forEach(function (el) { el.classList.remove('is-invalid'); });
    if (!state.domain || !isValidDomain(state.domain)) {
      errors.push('Enter a valid domain (e.g. your-store.com).');
      if (showUi) this.el('domain').classList.add('is-invalid');
    }
    var filled = [];
    state.items.forEach(function (item) {
      var vOk = /^\d+$/.test(item.variantId);
      var qOk = /^\d+$/.test(item.quantity) && parseInt(item.quantity, 10) >= 1;
      if (!item.variantId && !item.sellingPlanId) return;
      if (!vOk && showUi) item.row.querySelector('[data-field="variantId"]').classList.add('is-invalid');
      if (!qOk && showUi) item.row.querySelector('[data-field="quantity"]').classList.add('is-invalid');
      if (vOk && qOk) filled.push(item);
      else if (item.variantId || item.sellingPlanId) errors.push('Each product needs a numeric variant ID and a quantity of 1 or more.');
    });
    if (!filled.length) errors.push('Add at least one product with a valid variant ID.');
    if (state.discount) {
      var codes = state.discount.split(',').map(function (c) { return c.trim(); }).filter(Boolean);
      if (codes.some(function (c) { return c.indexOf(',') !== -1; })) errors.push('Discount codes cannot contain commas.');
      state.discountCodes = codes;
    } else {
      state.discountCodes = [];
    }
    state.validItems = filled;
    return errors;
  };

  KozPermalink.prototype.needsCartAdd = function (state) {
    return state.clearCart || state.validItems.some(function (item) { return !!item.sellingPlanId; });
  };

  KozPermalink.prototype.sharedParamPairs = function (state) {
    var pairs = [];
    if (state.note) pairs.push(['note', state.note]);
    if (state.ref) pairs.push(['ref', state.ref]);
    Object.keys(state.attributes).forEach(function (key) {
      pairs.push(['attributes[' + key + ']', state.attributes[key]]);
    });
    Object.keys(state.utm).forEach(function (key) {
      pairs.push([key, state.utm[key]]);
    });
    return pairs;
  };

  KozPermalink.prototype.appendSharedParams = function (qs, state) {
    this.sharedParamPairs(state).forEach(function (pair) {
      qs.set(pair[0], pair[1]);
    });
  };

  KozPermalink.prototype.joinQuery = function (pairs) {
    return pairs.map(function (pair) {
      return pair[0] + '=' + encodeURIComponent(pair[1] == null ? '' : String(pair[1]));
    }).join('&');
  };

  KozPermalink.prototype.buildClassic = function (state) {
    var loc = localePath(state.locale);
    var cartPath = loc + '/cart/' + state.validItems.map(function (item) {
      return item.variantId + ':' + item.quantity;
    }).join(',');
    var qs = new URLSearchParams();
    if (state.discountCodes.length) qs.set('discount', state.discountCodes.join(','));
    if (state.destination === 'cart') qs.set('storefront', 'true');
    this.appendSharedParams(qs, state);
    var keys = Object.keys(state.properties);
    if (keys.length) {
      if (keys.length > 25) keys = keys.slice(0, 25);
      var obj = {};
      keys.forEach(function (k) { obj[k] = state.properties[k]; });
      qs.set('properties', toBase64Url(JSON.stringify(obj)));
    }
    var query = qs.toString();
    return 'https://' + state.domain + cartPath + (query ? '?' + query : '');
  };

  KozPermalink.prototype.buildCartAdd = function (state) {
    var loc = localePath(state.locale);
    var destPairs = this.sharedParamPairs(state);
    var destPath = (state.destination === 'cart' ? '/cart' : '/checkout') +
      (destPairs.length ? '?' + this.joinQuery(destPairs) : '');
    if (state.discountCodes.length) {
      destPath = loc + '/discount/' + encodeURIComponent(state.discountCodes[0]) +
        '?redirect=' + encodeURIComponent(destPath);
    }
    var addPairs = [];
    state.validItems.forEach(function (item, i) {
      addPairs.push(['items[' + i + '][id]', item.variantId]);
      addPairs.push(['items[' + i + '][quantity]', item.quantity]);
      if (item.sellingPlanId) addPairs.push(['items[' + i + '][selling_plan]', item.sellingPlanId]);
      if (i === 0) {
        Object.keys(state.properties).forEach(function (key) {
          addPairs.push(['items[' + i + '][properties][' + key + ']', state.properties[key]]);
        });
      }
    });
    addPairs.push(['return_to', destPath]);
    var addPath = loc + '/cart/add?' + this.joinQuery(addPairs);
    if (state.clearCart) {
      return 'https://' + state.domain + loc + '/cart/clear?return_to=' + encodeURIComponent(addPath);
    }
    return 'https://' + state.domain + addPath;
  };

  KozPermalink.prototype.buildUrl = function (state) {
    if (this.needsCartAdd(state)) return this.buildCartAdd(state);
    return this.buildClassic(state);
  };

  KozPermalink.prototype.explain = function (url, state) {
    var bits = [];
    if (this.needsCartAdd(state)) {
      bits.push('Mode: cart-add. Classic /cart/id:qty permalinks cannot carry selling plans, and /cart/add appends unless you clear first.');
      if (state.clearCart) bits.push('Starts at /cart/clear, then /cart/add. Item keys are not double-encoded.');
      if (state.discountCodes.length) bits.push('Discount ' + state.discountCodes[0] + ' is applied after items are added, via return_to=/discount/CODE?redirect=… so it is never nested around /cart/add.');
      if (state.discountCodes.length > 1) bits.push('Only the first discount code is used in cart-add mode.');
    } else {
      bits.push('Mode: classic permalink. This replaces the current cart with the listed items.');
      bits.push('Path: /cart/' + state.validItems.map(function (i) { return i.variantId + ':' + i.quantity; }).join(','));
      if (state.destination === 'cart') bits.push('storefront=true sends the shopper to the cart instead of checkout.');
    }
    if (state.locale) bits.push('Locale prefix /' + state.locale.replace(/^\/+|\/+$/g, '') + ' localises checkout.');
    if (state.note) bits.push('note is stored on the order.');
    if (state.ref) bits.push('ref is stored as a referral code.');
    Object.keys(state.attributes).forEach(function (k) { bits.push('attributes[' + k + '] = ' + state.attributes[k]); });
    Object.keys(state.utm).forEach(function (k) { bits.push(k + ' = ' + state.utm[k]); });
    if (Object.keys(state.properties).length) bits.push('Line-item properties are attached to the first product.');
    if (url.length > 2000) bits.push('Length ' + url.length + ' characters — some tools truncate around 2,000.');
    return bits;
  };

  KozPermalink.prototype.schedulePreview = function () {
    var self = this;
    clearTimeout(this.previewTimer);
    this.previewTimer = setTimeout(function () { self.generate(false); }, 250);
    this.updateModeNotice();
  };

  KozPermalink.prototype.updateModeNotice = function () {
    var state = this.collectState();
    this.validate(state, false);
    var notice = this.el('mode-notice');
    var hasPlan = (state.validItems || []).some(function (i) { return i.sellingPlanId; });
    if (hasPlan || state.clearCart) {
      notice.hidden = false;
      notice.textContent = hasPlan
        ? 'A selling plan is set, so this link will use /cart/add (classic permalinks cannot attach subscriptions). Destination can still be cart or checkout.'
        : 'Clear-cart is on, so this link will use /cart/add after /cart/clear. Classic permalinks already replace the cart.';
    } else {
      notice.hidden = true;
    }
  };

  KozPermalink.prototype.generate = function (fromButton) {
    var state = this.collectState();
    var errors = this.validate(state, fromButton);
    if (errors.length) {
      this.el('results').hidden = true;
      if (fromButton) this.toast(errors[0], true);
      return;
    }
    var url = this.buildUrl(state);
    this.el('result').value = url;
    this.el('results').hidden = false;
    this.el('open-link').href = url;
    this.el('length-warn').hidden = url.length <= 2000;
    var list = this.el('explain');
    list.innerHTML = '';
    this.explain(url, state).forEach(function (line) {
      var li = document.createElement('li');
      li.textContent = line;
      list.appendChild(li);
    });
    this.drawQr(url);
    if (fromButton) {
      this.el('result').focus();
      this.el('result').select();
      this.saveRecent(url);
      this.persistDomain(state.domain);
      this.quietHowto();
    }
  };

  KozPermalink.prototype.copyResult = function (kind) {
    var url = this.el('result').value;
    if (!url) return;
    var text = url;
    if (kind === 'md') text = '[Checkout](' + url + ')';
    if (kind === 'html') text = '<a href="' + url.replace(/&/g, '&amp;').replace(/"/g, '&quot;') + '">Checkout</a>';
    var self = this;
    copyText(text).then(function () { self.toast('Copied to clipboard'); }).catch(function () { self.toast('Copy failed — select the URL instead', true); });
  };

  KozPermalink.prototype.verifyDomain = function () {
    var self = this;
    var domain = normalizeDomain(this.el('domain').value);
    var status = this.el('domain-status');
    var warn = this.el('myshopify-warn');
    warn.hidden = !/\.myshopify\.com$/i.test(domain);
    if (!domain || !isValidDomain(domain)) {
      status.hidden = true;
      return;
    }
    var apply = function (meta) {
      self.shopMeta = meta;
      status.hidden = false;
      status.className = 'kozperm__verify is-ok';
      status.textContent = 'Connected to ' + (meta.name || domain) + (meta.myshopify_domain ? ' (' + meta.myshopify_domain + ')' : '') + (meta.currency ? ' · ' + meta.currency : '');
    };
    if (this.metaCache[domain]) {
      apply(this.metaCache[domain]);
      return;
    }
    status.hidden = false;
    status.className = 'kozperm__verify';
    status.textContent = 'Checking store…';
    fetch('https://' + domain + '/meta.json')
      .then(function (r) { if (!r.ok) throw new Error('status'); return r.json(); })
      .then(function (meta) {
        self.metaCache[domain] = meta;
        apply(meta);
      })
      .catch(function () {
        status.className = 'kozperm__verify is-err';
        status.textContent = 'Could not verify that domain. You can still generate a link if you know it is correct.';
      });
  };

  KozPermalink.prototype.plansFromProduct = function (product, variantId) {
    var groups = product.selling_plan_groups || [];
    var variant = (product.variants || []).find(function (v) { return String(v.id) === String(variantId); });
    var alloc = (variant && variant.selling_plan_allocations) || [];
    var allowed = new Set(alloc.map(function (a) { return String(a.selling_plan_id); }));
    var plans = [];
    groups.forEach(function (group) {
      (group.selling_plans || []).forEach(function (plan) {
        if (!allowed.size || allowed.has(String(plan.id))) {
          plans.push({ id: plan.id, name: (group.name ? group.name + ': ' : '') + plan.name });
        }
      });
    });
    return plans;
  };

  KozPermalink.prototype.addVariant = function (variantId, product, options) {
    var silent = options && options.silent;
    var empty = null;
    this.el('lines').querySelectorAll('.kozperm__line').forEach(function (row) {
      if (!empty && !row.querySelector('[data-field="variantId"]').value.trim()) empty = row;
    });
    var variant = product && (product.variants || []).find(function (v) { return String(v.id) === String(variantId); });
    var title = product ? (product.title + (variant && variant.title && variant.title !== 'Default Title' ? ' — ' + variant.title : '')) : '';
    var plans = product ? this.plansFromProduct(product, variantId) : [];
    var row = empty || this.addLine();
    row.querySelector('[data-field="variantId"]').value = variantId;
    this.setSellingPlans(row, plans);
    if (title) {
      var chip = row.querySelector('[data-field="chip"]');
      chip.hidden = false;
      chip.textContent = title;
    }
    if (!silent) {
      this.el('product-url').value = '';
      this.updateModeNotice();
      this.schedulePreview();
      this.toast('Added variant ' + variantId);
    }
  };

  KozPermalink.prototype.fetchProduct = function () {
    var self = this;
    var raw = this.el('product-url').value.trim();
    if (!raw) {
      this.toast('Paste a product URL first.', true);
      return;
    }
    var str = /^https?:\/\//i.test(raw) ? raw : 'https://' + raw;
    var url;
    try { url = new URL(str); } catch (err) {
      this.toast('That does not look like a valid URL.', true);
      return;
    }
    if (!this.el('domain').value.trim()) {
      this.el('domain').value = url.host;
      this.verifyDomain();
    }
    var variantParam = url.searchParams.get('variant');
    if (variantParam) {
      this.addVariant(variantParam);
      return;
    }
    var match = url.pathname.match(/\/products\/([^\/\?]+)/);
    if (!match) {
      this.toast('Use a product URL that contains /products/handle.', true);
      return;
    }
    var btn = this.el('fetch-product');
    var label = this.el('fetch-label');
    var spinner = this.el('fetch-spinner');
    btn.disabled = true;
    label.hidden = true;
    spinner.hidden = false;
    fetch(url.origin + '/products/' + match[1] + '.js')
      .then(function (r) { if (!r.ok) throw new Error('fetch'); return r.json(); })
      .then(function (product) {
        if (!product.variants || !product.variants.length) throw new Error('novar');
        if (product.variants.length === 1) {
          self.addVariant(product.variants[0].id, product);
        } else {
          self.openVariantModal(product);
        }
      })
      .catch(function () {
        self.toast('Could not load that product. The store may block cross-origin requests. Paste ?variant=ID or enter the ID from Shopify admin.', true);
      })
      .finally(function () {
        btn.disabled = false;
        label.hidden = false;
        spinner.hidden = true;
      });
  };

  KozPermalink.prototype.openVariantModal = function (product) {
    var self = this;
    this.pendingProduct = product;
    this.el('modal-title').textContent = 'Select variants for “' + product.title + '”';
    var list = this.el('variant-list');
    list.innerHTML = '';
    var moneyFormat = (this.shopMeta && this.shopMeta.money_format) || '${{amount}}';
    product.variants.forEach(function (variant) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'kozperm__variant-btn';
      btn.disabled = variant.available === false;
      btn.setAttribute('aria-pressed', 'false');
      btn.setAttribute('data-variant-id', String(variant.id));
      var check = document.createElement('span');
      check.className = 'kozperm__variant-check';
      check.setAttribute('aria-hidden', 'true');
      var copy = document.createElement('span');
      copy.className = 'kozperm__variant-copy';
      var title = document.createElement('span');
      title.className = 'kozperm__variant-title';
      title.textContent = variant.title === 'Default Title' ? product.title : variant.title;
      var meta = document.createElement('span');
      meta.className = 'kozperm__variant-meta';
      var price = Number(variant.price);
      var compare = Number(variant.compare_at_price);
      if (compare > 0 && compare > price) {
        var was = document.createElement('s');
        was.className = 'kozperm__variant-compare';
        was.textContent = formatMoney(compare, moneyFormat);
        meta.appendChild(was);
      }
      var now = document.createElement('span');
      now.className = 'kozperm__variant-price';
      now.textContent = formatMoney(price, moneyFormat);
      meta.appendChild(now);
      var extra = [];
      if (variant.sku) extra.push('SKU ' + variant.sku);
      if (variant.available === false) extra.push('Sold out');
      if (extra.length) {
        var rest = document.createElement('span');
        rest.textContent = ' · ' + extra.join(' · ');
        meta.appendChild(rest);
      }
      copy.appendChild(title);
      copy.appendChild(meta);
      btn.appendChild(check);
      btn.appendChild(copy);
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var on = btn.classList.toggle('is-selected');
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        self.syncVariantPickerState();
      });
      list.appendChild(btn);
    });
    this.syncVariantPickerState();
    this.lastFocus = document.activeElement;
    this.el('modal').hidden = false;
    this.el('modal-panel').focus();
  };

  KozPermalink.prototype.selectableVariantButtons = function () {
    return Array.prototype.slice.call(this.el('variant-list').querySelectorAll('.kozperm__variant-btn:not(:disabled)'));
  };

  KozPermalink.prototype.syncVariantPickerState = function () {
    var selectable = this.selectableVariantButtons();
    var selected = selectable.filter(function (btn) { return btn.classList.contains('is-selected'); });
    var count = selected.length;
    var total = (this.pendingProduct && this.pendingProduct.variants && this.pendingProduct.variants.length) || 0;
    this.el('variant-selected-count').textContent = count === 1 ? '1 selected' : count + ' selected';
    var addBtn = this.el('add-selected-variants');
    addBtn.disabled = count === 0;
    addBtn.textContent = count === 0 ? 'Add selected' : (count === 1 ? 'Add 1 variant' : 'Add ' + count + ' variants');
    var allOn = selectable.length > 0 && selected.length === selectable.length;
    this.el('select-all-variants').textContent = allOn ? 'Deselect all' : 'Select all variants';
    var warn = this.el('variant-cap-warn');
    warn.hidden = !(total > VARIANT_URL_WARN || count > VARIANT_URL_WARN);
    if (!warn.hidden) {
      warn.textContent = 'This product has ' + total + ' variants. Adding more than ' + VARIANT_URL_WARN +
        ' can produce a URL over 2,000 characters, which some browsers, ads and SMS tools truncate. Generate a test link and open it before you go live.';
    }
  };

  KozPermalink.prototype.toggleSelectAllVariants = function () {
    var selectable = this.selectableVariantButtons();
    var allOn = selectable.length > 0 && selectable.every(function (btn) { return btn.classList.contains('is-selected'); });
    selectable.forEach(function (btn) {
      btn.classList.toggle('is-selected', !allOn);
      btn.setAttribute('aria-pressed', !allOn ? 'true' : 'false');
    });
    this.syncVariantPickerState();
  };

  KozPermalink.prototype.addSelectedVariants = function () {
    var self = this;
    var product = this.pendingProduct;
    var ids = this.selectableVariantButtons()
      .filter(function (btn) { return btn.classList.contains('is-selected'); })
      .map(function (btn) { return btn.getAttribute('data-variant-id'); });
    if (!ids.length) {
      this.toast('Select at least one variant.', true);
      return;
    }
    ids.forEach(function (id) { self.addVariant(id, product, { silent: true }); });
    this.el('product-url').value = '';
    this.updateModeNotice();
    this.schedulePreview();
    this.closeModal();
    this.toast(ids.length === 1 ? 'Added variant ' + ids[0] : 'Added ' + ids.length + ' variants');
  };

  KozPermalink.prototype.trapFocus = function (e) {
    if (e.key !== 'Tab') return;
    var panel = null;
    if (this.el('howto-modal') && !this.el('howto-modal').hidden) panel = this.el('howto-panel');
    else if (!this.el('modal').hidden) panel = this.el('modal-panel');
    if (!panel) return;
    var focusable = panel.querySelectorAll('button, [href], input, select, textarea, iframe, video, [tabindex]:not([tabindex="-1"])');
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  };

  KozPermalink.prototype.closeModal = function () {
    this.el('modal').hidden = true;
    if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
  };

  KozPermalink.prototype.howtoRaw = function () {
    var node = this.el('howto-raw');
    if (!node) return '';
    try { return JSON.parse(node.textContent || '""'); } catch (err) { return ''; }
  };

  KozPermalink.prototype.isHowtoQuiet = function () {
    try { return localStorage.getItem(LS_HOWTO) === '1'; } catch (err) { return false; }
  };

  KozPermalink.prototype.quietHowto = function () {
    try { localStorage.setItem(LS_HOWTO, '1'); } catch (err) {}
    this.syncHowtoChip();
  };

  KozPermalink.prototype.syncHowtoChip = function () {
    var chip = this.el('howto-chip');
    var open = this.el('howto-corner');
    if (!chip || !open) return;
    var quiet = this.isHowtoQuiet();
    chip.classList.toggle('is-quiet', quiet);
    open.textContent = quiet ? '?' : 'How to use this tool';
    open.setAttribute('aria-label', 'How to use this tool');
  };

  KozPermalink.prototype.howtoMountKey = function (parsed) {
    return parsed.type + ':' + (parsed.videoId || parsed.src || parsed.iframeSrc || '');
  };

  KozPermalink.prototype.pauseHowtoMedia = function () {
    var frame = this.el('howto-frame');
    if (!frame) return;
    frame.querySelectorAll('video').forEach(function (media) {
      try { media.pause(); } catch (err) {}
    });
    frame.querySelectorAll('iframe').forEach(function (iframe) {
      try {
        iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }), '*');
        iframe.contentWindow.postMessage({ method: 'pause' }, '*');
        iframe.contentWindow.postMessage({ type: 'PLAYER_PAUSE' }, '*');
      } catch (err) {}
    });
  };

  KozPermalink.prototype.reloadHowtoIframes = function () {
    var frame = this.el('howto-frame');
    if (!frame) return;
    frame.querySelectorAll('iframe').forEach(function (iframe) {
      var src = iframe.getAttribute('src');
      if (!src) return;
      iframe.src = 'about:blank';
      iframe.src = src;
    });
  };

  KozPermalink.prototype.isHowtoMediaEvent = function (e) {
    var path = e.composedPath ? e.composedPath() : [];
    var i;
    for (i = 0; i < path.length; i++) {
      var node = path[i];
      if (!node || !node.tagName) continue;
      var tag = node.tagName.toLowerCase();
      if (tag === 'iframe' || tag === 'video') return true;
      if (node.classList && (
        node.classList.contains('hs-video-widget') ||
        node.classList.contains('kozperm__howto-frame') ||
        node.classList.contains('kozperm__howto-hs')
      )) return true;
    }
    return false;
  };

  KozPermalink.prototype.appendHowtoIframe = function (src) {
    var iframe = document.createElement('iframe');
    iframe.src = src;
    iframe.title = 'How to use this tool';
    iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen; web-share');
    iframe.setAttribute('allowfullscreen', 'true');
    iframe.setAttribute('webkitallowfullscreen', 'true');
    iframe.setAttribute('playsinline', 'true');
    iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
    this.el('howto-frame').appendChild(iframe);
  };

  KozPermalink.prototype.mountHowtoPlayer = function (parsed) {
    var frame = this.el('howto-frame');
    frame.innerHTML = '';
    this.howtoPlayerKey = this.howtoMountKey(parsed);
    if (parsed.type === 'hubspot') {
      this.appendHowtoIframe(parsed.iframeSrc);
      return;
    }
    if (parsed.type === 'video') {
      var video = document.createElement('video');
      video.controls = true;
      video.playsInline = true;
      video.setAttribute('webkit-playsinline', 'true');
      video.setAttribute('playsinline', 'true');
      video.preload = 'metadata';
      video.src = parsed.src;
      frame.appendChild(video);
      return;
    }
    this.appendHowtoIframe(parsed.src || parsed.iframeSrc);
  };

  KozPermalink.prototype.openHowtoModal = function () {
    var parsed = parseHowToEmbed(this.howtoRaw());
    if (!parsed) {
      this.toast('The how-to video could not be loaded. Paste a HubSpot, YouTube, Vimeo or Shopify video embed in the theme editor.', true);
      return;
    }
    if (this.el('modal') && !this.el('modal').hidden) this.closeModal();
    this.mountHowtoPlayer(parsed);
    this.quietHowto();
    this.howtoLastFocus = document.activeElement;
    this.howtoOpenedAt = Date.now();
    this.el('howto-modal').hidden = false;
    if (!window.matchMedia('(pointer: coarse)').matches) {
      this.el('howto-panel').focus();
    }
  };

  KozPermalink.prototype.closeHowtoModal = function () {
    var modal = this.el('howto-modal');
    if (!modal) return;
    this.pauseHowtoMedia();
    modal.hidden = true;
    var frame = this.el('howto-frame');
    if (frame) frame.innerHTML = '';
    this.howtoPlayerKey = '';
    if (this.howtoLastFocus && this.howtoLastFocus.focus) this.howtoLastFocus.focus();
  };

  KozPermalink.prototype.clearForm = function () {
    this.el('domain').value = '';
    this.el('product-url').value = '';
    this.el('discount').value = '';
    this.el('locale').value = '';
    this.el('note').value = '';
    this.el('ref').value = '';
    this.el('clear-cart').checked = false;
    this.root.querySelector('[data-kozperm="dest"][value="cart"]').checked = true;
    this.el('lines').innerHTML = '';
    this.el('attr-list').innerHTML = '';
    this.el('prop-list').innerHTML = '';
    this.root.querySelectorAll('[data-utm]').forEach(function (el) { el.value = ''; });
    var utmPanel = this.el('utm-panel');
    if (utmPanel) utmPanel.open = false;
    var advancedPanel = this.el('advanced-panel');
    if (advancedPanel) advancedPanel.open = false;
    this.el('results').hidden = true;
    this.el('domain-status').hidden = true;
    this.el('myshopify-warn').hidden = true;
    this.addLine();
    this.el('domain').focus();
  };

  KozPermalink.prototype.persistDomain = function (domain) {
    try { localStorage.setItem(LS_DOMAIN, domain); } catch (err) {}
  };

  KozPermalink.prototype.saveRecent = function (url) {
    try {
      var list = JSON.parse(localStorage.getItem(LS_RECENT) || '[]');
      list = [{ url: url, ts: Date.now() }].concat(list.filter(function (item) { return item.url !== url; })).slice(0, 10);
      localStorage.setItem(LS_RECENT, JSON.stringify(list));
      this.renderRecent();
    } catch (err) {}
  };

  KozPermalink.prototype.renderRecent = function () {
    var listEl = this.el('recent');
    var card = this.el('recent-card');
    var list = [];
    try { list = JSON.parse(localStorage.getItem(LS_RECENT) || '[]'); } catch (err) {}
    if (!list.length) {
      card.hidden = true;
      return;
    }
    card.hidden = false;
    listEl.innerHTML = '';
    list.forEach(function (item) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = item.url;
      a.target = '_blank';
      a.rel = 'noopener noreferrer';
      a.textContent = item.url;
      li.appendChild(a);
      listEl.appendChild(li);
    });
  };

  KozPermalink.prototype.restoreLocal = function () {
    try {
      var domain = localStorage.getItem(LS_DOMAIN);
      if (domain && !this.el('domain').value) {
        this.el('domain').value = domain;
        this.verifyDomain();
      }
    } catch (err) {}
  };

  KozPermalink.prototype.serialise = function () {
    var state = this.collectState();
    return {
      domain: state.domain,
      locale: state.locale,
      destination: state.destination,
      clearCart: state.clearCart,
      discount: state.discount,
      note: state.note,
      ref: state.ref,
      attributes: state.attributes,
      properties: state.properties,
      utm: state.utm,
      items: state.items.map(function (item) {
        return { variantId: item.variantId, quantity: item.quantity, sellingPlanId: item.sellingPlanId };
      })
    };
  };

  KozPermalink.prototype.applyState = function (data) {
    var self = this;
    if (data.domain) this.el('domain').value = data.domain;
    if (data.locale) this.el('locale').value = data.locale;
    if (data.discount) this.el('discount').value = data.discount;
    if (data.note) this.el('note').value = data.note;
    if (data.ref) this.el('ref').value = data.ref;
    this.el('clear-cart').checked = !!data.clearCart;
    var dest = this.root.querySelector('[data-kozperm="dest"][value="' + (data.destination || 'cart') + '"]');
    if (dest) dest.checked = true;
    this.el('attr-list').innerHTML = '';
    Object.keys(data.attributes || {}).forEach(function (k) { self.addKv('attr-list', k, data.attributes[k]); });
    this.el('prop-list').innerHTML = '';
    Object.keys(data.properties || {}).forEach(function (k) { self.addKv('prop-list', k, data.properties[k]); });
    Object.keys(data.utm || {}).forEach(function (k) {
      var input = self.root.querySelector('[data-utm="' + k + '"]');
      if (input) input.value = data.utm[k];
    });
    var utmPanel = this.el('utm-panel');
    if (utmPanel && data.utm && Object.keys(data.utm).length) utmPanel.open = true;
    var advancedPanel = this.el('advanced-panel');
    if (advancedPanel && (data.locale || data.note || data.ref || (data.attributes && Object.keys(data.attributes).length) || (data.properties && Object.keys(data.properties).length))) {
      advancedPanel.open = true;
    }
    this.el('lines').innerHTML = '';
    (data.items && data.items.length ? data.items : [{}]).forEach(function (item) { self.addLine(item); });
    if (data.domain) this.verifyDomain();
    this.schedulePreview();
  };

  KozPermalink.prototype.copyShareLink = function () {
    var packed = toBase64Url(JSON.stringify(this.serialise()));
    var share = location.origin + location.pathname + '?s=' + packed;
    var self = this;
    copyText(share).then(function () { self.toast('Generator link copied'); });
  };

  KozPermalink.prototype.restoreShare = function () {
    var param = new URLSearchParams(location.search).get('s');
    if (!param) return;
    try {
      this.applyState(JSON.parse(fromBase64Url(param)));
    } catch (err) {
      this.toast('Could not restore the shared generator state.', true);
    }
  };

  KozPermalink.prototype.parseBulk = function () {
    var lines = this.el('bulk').value.split(/\r?\n/);
    var rows = [];
    lines.forEach(function (line) {
      var trimmed = line.trim();
      if (!trimmed) return;
      var parts = trimmed.split(/[,:]/).map(function (p) { return p.trim(); });
      if (!/^\d+$/.test(parts[0])) return;
      rows.push({ variantId: parts[0], quantity: /^\d+$/.test(parts[1]) ? parts[1] : '1' });
    });
    return rows;
  };

  KozPermalink.prototype.runBulk = function () {
    var rows = this.parseBulk();
    if (!rows.length) {
      this.toast('Paste at least one variantId,quantity line.', true);
      return;
    }
    var base = this.collectState();
    var errors = this.validate(base, true);
    if (errors.length && errors[0].indexOf('variant') === -1 && !base.domain) {
      this.toast(errors[0], true);
      return;
    }
    if (!base.domain || !isValidDomain(base.domain)) {
      this.toast('Enter a valid store domain first.', true);
      return;
    }
    var self = this;
    this.bulkRows = rows.map(function (row) {
      var state = self.collectState();
      state.validItems = [{ variantId: row.variantId, quantity: row.quantity, sellingPlanId: '' }];
      state.discountCodes = state.discount ? state.discount.split(',').map(function (c) { return c.trim(); }).filter(Boolean) : [];
      return { variantId: row.variantId, quantity: row.quantity, url: self.buildUrl(state) };
    });
    var out = this.el('bulk-out');
    out.hidden = false;
    out.innerHTML = this.bulkRows.map(function (row) {
      return '<div><strong>' + row.variantId + ' × ' + row.quantity + '</strong><br>' + row.url + '</div>';
    }).join('');
    this.toast('Generated ' + this.bulkRows.length + ' links');
  };

  KozPermalink.prototype.downloadCsv = function () {
    if (!this.bulkRows.length) this.runBulk();
    if (!this.bulkRows.length) return;
    var csv = 'Variant ID,Quantity,URL\n' + this.bulkRows.map(function (row) {
      return row.variantId + ',' + row.quantity + ',"' + row.url.replace(/"/g, '""') + '"';
    }).join('\n');
    var blob = new Blob([csv], { type: 'text/csv' });
    var a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = 'shopify-permalinks.csv';
    a.click();
    URL.revokeObjectURL(a.href);
  };

  KozPermalink.prototype.qrImageUrl = function (text, size) {
    size = size || 180;
    return 'https://api.qrserver.com/v1/create-qr-code/?size=' + size + 'x' + size +
      '&margin=16&ecc=M&color=0d1f3c&bgcolor=ffffff&data=' + encodeURIComponent(text);
  };

  KozPermalink.prototype.drawQr = function (text) {
    var img = this.el('qr');
    var download = this.el('download-qr');
    if (!text) {
      img.hidden = true;
      download.hidden = true;
      img.removeAttribute('src');
      return;
    }
    img.hidden = false;
    download.hidden = false;
    img.alt = 'QR code for the generated permalink';
    img.src = this.qrImageUrl(text, 180);
    img.onerror = function () {
      img.hidden = true;
      download.hidden = true;
      img.removeAttribute('src');
    };
  };

  KozPermalink.prototype.downloadQr = function () {
    var self = this;
    var url = this.el('result').value;
    if (!url) {
      this.toast('Generate a link first.', true);
      return;
    }
    var src = this.qrImageUrl(url, 1000);
    fetch(src)
      .then(function (r) { if (!r.ok) throw new Error('qr'); return r.blob(); })
      .then(function (blob) {
        var a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = qrDownloadFilename(self.el('domain').value || url);
        document.body.appendChild(a);
        a.click();
        a.remove();
        setTimeout(function () { URL.revokeObjectURL(a.href); }, 1000);
        self.toast('QR code downloaded');
      })
      .catch(function () {
        window.open(src, '_blank', 'noopener,noreferrer');
        self.toast('Opened QR image — save it from the new tab if the download was blocked.');
      });
  };

  function initAll(scope) {
    (scope || document).querySelectorAll('.kozperm').forEach(function (root) {
      if (root.dataset.kozpermReady) return;
      root.dataset.kozpermReady = '1';
      new KozPermalink(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["navigation-footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super()
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
      }
      this.querySelectorAll('a').forEach((item) =>
        item.addEventListener('click', this.onItemClick.bind(this))
      )
    }

    onItemClick(event) {
      event.preventDefault()
      const form = this.querySelector('form')
      this.elements.input.value = event.currentTarget.dataset.value
      if (form) form.submit()
    }
  }

  customElements.define('localization-form', LocalizationForm)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["revenue-calculator-v2"] && !Shopify.designMode) return;
  try {
    
class RevenueCalculatorV2 {
  constructor(root) {
    this.root = root;
    const upliftRaw = String(root.dataset.uplift || '').replace(/[^\d.]/g, '');
    const upliftParsed = parseFloat(upliftRaw);
    this.uplift = (Number.isFinite(upliftParsed) && upliftParsed > 0 ? upliftParsed : 10) / 100;
    this.currency = root.dataset.currency || 'AUD';

    this.revenueInput = root.querySelector('[data-input="revenue"]');
    this.revenueSlider = root.querySelector('[data-slider="revenue"]');

    this.bounds = {
      min: Number(root.dataset.revenueMin),
      max: Number(root.dataset.revenueMax),
      step: Number(root.dataset.revenueStep)
    };

    this.outputs = {
      annualIncrease: root.querySelector('[data-output="annual-increase"]'),
      monthlyIncrease: root.querySelector('[data-output="monthly-increase"]'),
      threeYearIncrease: root.querySelector('[data-output="three-year-increase"]')
    };

    this.positiveCurrencyFormatter = new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: this.currency,
      currencyDisplay: 'narrowSymbol',
      maximumFractionDigits: 0,
      signDisplay: 'exceptZero'
    });

    this.numberFormatter = new Intl.NumberFormat(undefined, {
      maximumFractionDigits: 0
    });

    this.bindEvents();
    this.formatInitialInput();
    this.syncSliderProgress();
    this.update();
  }

  formatInitialInput() {
    const revenue = this.parseNumber(this.revenueInput.value);

    if (revenue > 0) {
      this.revenueInput.value = this.numberFormatter.format(revenue);
      this.revenueSlider.value = this.clamp(revenue, this.bounds.min, this.bounds.max);
    }
  }

  bindEvents() {
    this.revenueSlider.addEventListener('input', () => {
      const value = Number(this.revenueSlider.value);
      this.revenueInput.value = this.numberFormatter.format(value);
      this.syncSliderProgress();
      this.update();
    });

    this.revenueInput.addEventListener('input', () => {
      const value = this.parseNumber(this.revenueInput.value);
      this.revenueInput.value = value ? this.numberFormatter.format(value) : '';
      this.revenueSlider.value = this.clamp(value, this.bounds.min, this.bounds.max);
      this.syncSliderProgress();
      this.update();
    });
  }

  parseNumber(value) {
    const digits = String(value).replace(/[^\d]/g, '');
    return digits ? Number(digits) : 0;
  }

  clamp(value, min, max) {
    if (!value || value <= 0) {
      return min;
    }

    return Math.min(Math.max(value, min), max);
  }

  syncSliderProgress() {
    const min = Number(this.revenueSlider.min);
    const max = Number(this.revenueSlider.max);
    const value = Number(this.revenueSlider.value);
    const progress = ((value - min) / (max - min)) * 100;
    this.revenueSlider.style.setProperty('--slider-progress', `${progress}%`);
  }

  getRevenue() {
    return this.parseNumber(this.revenueInput.value);
  }

  update() {
    const revenue = this.getRevenue();

    if (!revenue || revenue <= 0) {
      this.setOutput('annualIncrease', '+$0');
      this.setOutput('monthlyIncrease', '+$0');
      this.setOutput('threeYearIncrease', '+$0');
      return;
    }

    const monthlyIncrease = revenue * this.uplift;
    const annualIncrease = monthlyIncrease * 12;
    const threeYearIncrease = annualIncrease * 3;

    this.setOutput('annualIncrease', this.formatPositive(annualIncrease));
    this.setOutput('monthlyIncrease', this.formatPositive(monthlyIncrease));
    this.setOutput('threeYearIncrease', this.formatPositive(threeYearIncrease));
  }

  setOutput(key, value) {
    if (this.outputs[key]) {
      this.outputs[key].textContent = value;
    }
  }

  formatPositive(value) {
    const formatted = this.positiveCurrencyFormatter.format(value);
    return formatted.startsWith('+') ? formatted : `+${formatted}`;
  }
}

function initRevenueCalculatorsV2(scope = document) {
  scope.querySelectorAll('.revcalc2').forEach((root) => {
    if (root.dataset.initialized === 'true') {
      return;
    }

    new RevenueCalculatorV2(root);
    root.dataset.initialized = 'true';
  });
}

initRevenueCalculatorsV2();

if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    initRevenueCalculatorsV2(event.target);
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["revenue-calculator"] && !Shopify.designMode) return;
  try {
    
class RevenueCalculator {
  constructor(root) {
    this.root = root;
    this.uplift = Number(root.dataset.uplift) / 100;
    this.currency = root.dataset.currency || 'AUD';

    this.visitorsInput = root.querySelector('[data-input="visitors"]');
    this.revenueInput = root.querySelector('[data-input="revenue"]');
    this.visitorsSlider = root.querySelector('[data-slider="visitors"]');
    this.revenueSlider = root.querySelector('[data-slider="revenue"]');

    this.bounds = {
      visitors: {
        min: Number(root.dataset.visitorsMin),
        max: Number(root.dataset.visitorsMax),
        step: Number(root.dataset.visitorsStep)
      },
      revenue: {
        min: Number(root.dataset.revenueMin),
        max: Number(root.dataset.revenueMax),
        step: Number(root.dataset.revenueStep)
      }
    };

    this.outputs = {
      currentRpv: root.querySelector('[data-output="current-rpv"]'),
      liftedRpv: root.querySelector('[data-output="lifted-rpv"]'),
      annualIncrease: root.querySelector('[data-output="annual-increase"]'),
      monthlyIncrease: root.querySelector('[data-output="monthly-increase"]'),
      threeYearIncrease: root.querySelector('[data-output="three-year-increase"]')
    };

    this.currencyFormatter = new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: this.currency,
      currencyDisplay: 'narrowSymbol',
      maximumFractionDigits: 0
    });

    this.positiveCurrencyFormatter = new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: this.currency,
      currencyDisplay: 'narrowSymbol',
      maximumFractionDigits: 0,
      signDisplay: 'exceptZero'
    });

    this.rpvFormatter = new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: this.currency,
      currencyDisplay: 'narrowSymbol',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

    this.numberFormatter = new Intl.NumberFormat(undefined, {
      maximumFractionDigits: 0
    });

    this.bindEvents();
    this.formatInitialInputs();
    this.syncSliderProgress();
    this.update();
  }

  formatInitialInputs() {
    const visitors = this.parseNumber(this.visitorsInput.value);
    const revenue = this.parseNumber(this.revenueInput.value);

    if (visitors > 0) {
      this.visitorsInput.value = this.numberFormatter.format(visitors);
      this.visitorsSlider.value = this.clamp(visitors, this.bounds.visitors.min, this.bounds.visitors.max);
    }

    if (revenue > 0) {
      this.revenueInput.value = this.numberFormatter.format(revenue);
      this.revenueSlider.value = this.clamp(revenue, this.bounds.revenue.min, this.bounds.revenue.max);
    }
  }

  bindEvents() {
    this.visitorsSlider.addEventListener('input', () => {
      const value = Number(this.visitorsSlider.value);
      this.visitorsInput.value = this.numberFormatter.format(value);
      this.syncSliderProgress();
      this.update();
    });

    this.revenueSlider.addEventListener('input', () => {
      const value = Number(this.revenueSlider.value);
      this.revenueInput.value = this.numberFormatter.format(value);
      this.syncSliderProgress();
      this.update();
    });

    this.visitorsInput.addEventListener('input', () => {
      const value = this.parseNumber(this.visitorsInput.value);
      this.visitorsInput.value = value ? this.numberFormatter.format(value) : '';
      this.visitorsSlider.value = this.clamp(value, this.bounds.visitors.min, this.bounds.visitors.max);
      this.syncSliderProgress();
      this.update();
    });

    this.revenueInput.addEventListener('input', () => {
      const value = this.parseNumber(this.revenueInput.value);
      this.revenueInput.value = value ? this.numberFormatter.format(value) : '';
      this.revenueSlider.value = this.clamp(value, this.bounds.revenue.min, this.bounds.revenue.max);
      this.syncSliderProgress();
      this.update();
    });
  }

  parseNumber(value) {
    const digits = String(value).replace(/[^\d]/g, '');
    return digits ? Number(digits) : 0;
  }

  clamp(value, min, max) {
    if (!value || value <= 0) {
      return min;
    }

    return Math.min(Math.max(value, min), max);
  }

  syncSliderProgress() {
    [this.visitorsSlider, this.revenueSlider].forEach((slider) => {
      const min = Number(slider.min);
      const max = Number(slider.max);
      const value = Number(slider.value);
      const progress = ((value - min) / (max - min)) * 100;
      slider.style.setProperty('--slider-progress', `${progress}%`);
    });
  }

  getValues() {
    return {
      visitors: this.parseNumber(this.visitorsInput.value),
      revenue: this.parseNumber(this.revenueInput.value)
    };
  }

  update() {
    const { visitors, revenue } = this.getValues();

    if (!visitors || !revenue || visitors <= 0 || revenue <= 0) {
      this.outputs.currentRpv.textContent = '—';
      this.outputs.liftedRpv.textContent = '—';
      this.outputs.annualIncrease.textContent = '+$0';
      this.outputs.monthlyIncrease.textContent = '+$0';
      this.outputs.threeYearIncrease.textContent = '+$0';
      return;
    }

    const rpv = revenue / visitors;
    const liftedRpv = rpv * (1 + this.uplift);
    const monthlyIncrease = revenue * this.uplift;
    const annualIncrease = monthlyIncrease * 12;
    const threeYearIncrease = annualIncrease * 3;

    this.outputs.currentRpv.textContent = this.rpvFormatter.format(rpv);
    this.outputs.liftedRpv.textContent = this.rpvFormatter.format(liftedRpv);
    this.outputs.annualIncrease.textContent = this.formatPositive(annualIncrease);
    this.outputs.monthlyIncrease.textContent = this.formatPositive(monthlyIncrease);
    this.outputs.threeYearIncrease.textContent = this.formatPositive(threeYearIncrease);
  }

  formatPositive(value) {
    const formatted = this.positiveCurrencyFormatter.format(value);
    return formatted.startsWith('+') ? formatted : `+${formatted}`;
  }
}

function initRevenueCalculators(scope = document) {
  scope.querySelectorAll('.revcalc').forEach((root) => {
    if (root.dataset.initialized === 'true') {
      return;
    }

    new RevenueCalculator(root);
    root.dataset.initialized = 'true';
  });
}

initRevenueCalculators();

if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    initRevenueCalculators(event.target);
  });
}

  } catch(e) { console.error(e); }
})();
})();
